import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BellSimple } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function Notifications() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/notifications");
        setRows(data);
        api.post("/notifications/mark-read").catch(() => {});
      } catch {}
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div>
        <div className="text-xs uppercase tracking-widest font-bold text-stone-500">Alerts</div>
        <div className="font-display text-2xl font-bold text-stone-900">Notifications</div>
      </div>
      <div className="rounded-xl bg-white border border-stone-200 divide-y divide-stone-100">
        {rows === null && Array.from({ length: 3 }).map((_, i) => <div key={i} className="p-4"><div className="h-6 shimmer rounded" /></div>)}
        {rows && rows.length === 0 && <div className="p-10 text-center text-stone-500">You're all caught up.</div>}
        {rows && rows.map((n, i) => (
          <motion.div key={n.id} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }} className="p-4 flex items-start gap-3">
            <div className={`w-9 h-9 rounded-md grid place-items-center shrink-0 ${n.read ? "bg-stone-100 text-stone-500" : "bg-orange-100 text-orange-600"}`}>
              <BellSimple weight="duotone" size={18} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-stone-800">{n.title}</div>
              <div className="text-sm text-stone-600">{n.message}</div>
              <div className="text-xs text-stone-400 font-mono mt-1">{new Date(n.created_at).toLocaleString("en-IN")}</div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
